import React from 'react';
import { cn } from './cn';

/**
 * A surface panel.
 *
 * Depth comes from the surface ramp plus a 1px lit top edge (shadow-hairline),
 * not a drop shadow — a shadow does almost nothing against black.
 *
 * `min-w-0` is on by default and is load-bearing: a Card is usually a grid or
 * flex item, both of which refuse to shrink below their content's min-content
 * width, so a long name inside would otherwise widen the whole track past the
 * viewport however hard the text truncates.
 */
export const Card = React.forwardRef(function Card(
  { as: Tag = 'div', size = 'md', interactive, className, ...props },
  ref
) {
  return (
    <Tag
      ref={ref}
      className={cn(
        'min-w-0 bg-surface border border-line shadow-hairline',
        // A real variant rather than a padding override from `className`:
        // cn() appends, it does not resolve Tailwind conflicts, so a caller
        // passing `p-2` would leave both `p-3.5` and `p-2` on the element and
        // let stylesheet order decide which wins.
        size === 'lg' ? 'rounded-panel p-4 sm:p-7'
          : size === 'sm' ? 'rounded-card p-2 sm:p-2.5'
          : 'rounded-card p-3.5 sm:p-5',
        interactive && [
          'cursor-pointer transition-[border-color,background-color,transform]',
          'duration-200 ease-[cubic-bezier(.22,.61,.36,1)]',
          'hover:border-line-strong hover:bg-surface-raised active:scale-[.995]',
        ].join(' '),
        className
      )}
      {...props}
    />
  );
});

export default Card;
